import React from "react";
import corona from "../assets/images/corona.jpg";
import movies from "../assets/images/movies.jpg";
import beat from "../assets/images/beat.jpg";
import airbnb from "../assets/images/airbnb.jpg";
import diary from "../assets/images/diary.jpg";
//import movies from "../assets/images/movies.png";
import loading from "../assets/images/loading.png";
import Card from "../components/Card";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/Row";

class Carousel extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            items:[
                {
                    id: 0,
                    title: "Covid-19 Tracker",
                    subtitle: "Provides worldwide daily data for Covid-19 stats",
                    imgSrc:corona,
                    link:"https://covid-19-tracker-a2758.web.app",
                    selected:false
                },
               {
                    id: 1,
                    title: "Movies Info",
                    subtitle: "Information on top movies",
                    imgSrc:movies,
                    link:"https://hulu-clone-eef63.web.app",
                    selected:false
                },
                {
                    id: 2,
                    title: "Barefoot Afrika Education Trust",
                    subtitle: "Policy, Land Reform & Agriculture In Africa",
                    imgSrc:beat,
                    link:"https://www.beatafrika.org",
                    selected:false
                }, 
                {
                    id:3,
                    title: "AirBnB Clone",
                    subtitle: "Accommodation rentals",
                    imgSrc: airbnb,
                    link: "https://airbnb-clone-59f5c.web.app",
                    selected: false
                },
                {
                    id: 4,
                    title: "Digital Diary",
                    subtitle: "Plan your activities",
                    imgSrc: diary,
                    link: "https://todo-40151.web.app",
                    selected: false
                },
            ]
        }
    }

    handleCardClick = (id, card) =>{

        let items = [...this.state.items];

        items[id].selected = items[id].selected ? false : true;

        items.forEach(item => {
            if(item.id != id){
                item.selected = false;
            }
        });
        this.setState({
            items
        });
    }

    makeItems = (items) =>{
        return items.map(item =>{
            return <Card item={item} click={(e => this.handleCardClick(item.id, e))} key={item.id} />
        })
    }

    render(){
        return(
            <Container fluid={true}>
                <Row className="justify-content-around">
                    {this.makeItems(this.state.items)}
                </Row>
            </Container>
        );
    }

}

export default Carousel;